import { InquiryService } from './../../../inquiries/services/inquiry.service';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { DVFormGroup, DVFormControl } from './../../../shared/helpers/dynamic-validators/dynamic-validator';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { TravelersService } from '../../services/travelers.service';

@Component({
  selector: 'app-view-traveler',
  templateUrl: './view-traveler.component.html',
  styleUrls: ['./view-traveler.component.css']
})
export class ViewTravelerComponent implements OnInit {
  @Input() travelerRow;
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeViewModal', { static: false })
  closeViewModal: ElementRef;
  @Output() return = new EventEmitter();
  traveler: ViewTraveler;
  rowAcc: any;

  constructor(
    private travelersService: TravelersService
  ) {
  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.traveler = undefined;
    this.travelersService.getTravelerBy_UUID(this.travelerRow.uuid).subscribe(res => {
      this.traveler = res.data.traveler;
    },
      err => {
        console.log(err);
      })
  }

}

interface ViewTraveler {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  TravelerInfo: {
    status: string
  };
}

